import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import useAppCustom from '@hooks/useAppCustom';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import CouponHistoryFragment from './fragments/CouponHistoryFragment';
import DownloadCouponFragment from './fragments/DownloadCouponFragment';
import ExternalCouponFragment from './fragments/ExternalCouponFragment';
import MyCouponFragment from './fragments/MyCouponFragment';

interface Params {
    type: 'MY' | 'DOWNLOAD' | 'HISTORY' | 'EXTERNAL';
}

const CouponActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { type } = params;
  const { stepReplace } = useStepFlow('CouponActivity');
  const { useExternalCouponInCoupon } = useAppCustom().coupon;
  return (
        <AppScreen>
            <Header title='쿠폰함' noShadow/>
            <TabList variant='solid'>
                <TabItem selected={type === 'MY'}
                         onClick={() => stepReplace({ type: 'MY' })}>
                    MY 쿠폰
                </TabItem>
                <TabItem selected={type === 'DOWNLOAD'}
                         onClick={() => stepReplace({ type: 'DOWNLOAD' })}>
                    쿠폰 다운로드
                </TabItem>
                {useExternalCouponInCoupon && (
                    <TabItem selected={type === 'EXTERNAL'}
                             onClick={() => stepReplace({ type: 'EXTERNAL' })}>
                        외부 쿠폰 등록
                    </TabItem>
                )}
                <TabItem selected={type === 'HISTORY'}
                         onClick={() => stepReplace({ type: 'HISTORY' })}>
                    쿠폰 히스토리
                </TabItem>
            </TabList>
            {type === 'MY' && (
                <MyCouponFragment/>
            )}
            {type === 'DOWNLOAD' && (
                <DownloadCouponFragment/>
            )}
            {type === 'HISTORY' && (
                <CouponHistoryFragment/>
            )}
            {type === 'EXTERNAL' && (
                <ExternalCouponFragment/>
            )}
        </AppScreen>
  );
};

export default CouponActivity;
